export default "__VITE_ASSET__D4LdDgC3__"